import { MitraServerService } from '@/services/mitraserver.service'
import router from '../router/'
const state = {
    dialog: false,
    loading: false,
    show: false,
    type: null,
    message: null,
    dialogutama: false,
    colordialog: 'indigo',
    judul: '',
    color: '',
    list: []
};


const actions = {
    OpenDialogForm({commit }) {
        commit('opendialog');
    },
    closeDialog({commit }) {
        commit('closedialog');
    },
    Daftar({ dispatch }, newData) {
        MitraServerService.add(newData)
            .then(() => {
                dispatch('alert/success', 'Signup Successfully, cek email for activation link', { root: true });
                router.push('/login');
            }, error => {
                dispatch('alert/error', error, { root: true });
            })
    },
}


const mutations = {
    ShowAdd(state, data) {
        console.log(data);
        state.dialog = false;
    },
    addResponseApp(state, apps) {
        state.list = []
        state.list = apps.data;
        //console.log(state.applist[0]);
    },
    opendialog(state) {
        state.dialog = true
    },
    closedialog(state) {
        state.dialog = false
    }
}


export const mitra = {
    namespaced: true,
    state,
    actions,
    mutations
};
